export enum KeywordsTabSegmentEnum {
    TagsCloud = 'TagsCloud',
    Chart = 'Chart',
}
